@use '@shared/styles/media' as media;

.header-container {
  background-color: var(--tg-theme-header-bg-color);
}

.header {
  padding: 0.5rem 0;
  color: var(--tg-theme-text-color);

  &__account-info {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  &__home-btn {
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      color: var(--tg-theme-text-color);
      transition: 250ms;

      &:hover {
        color: var(--tg-theme-text-color);
      }
    }
  }

  &__user-info {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    color: var(--tg-theme-text-color);

    img {
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      object-fit: cover;
    }
  }
}
